if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
        this.hotspotButtons = this.querySelectorAll('[data-hotspot]');
        this.closeOverlayButtons = this.querySelectorAll('[data-hide-overlay]');
        this.hotspotReveals = this.querySelectorAll('[data-hotspot-target]');
        this.staticContent = this.querySelector('[data-static-content]');
        this.slider = this.querySelector('slider-component');

        // Esc listener to close overlays
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeAllReveals());

        this.addEventListener('click', (event) => {
          if (event.target.hasAttribute('data-hotspot')) {
            this.closeAllReveals();
            const hotspot = event.target;
            const animatedElements = hotspot.querySelectorAll('[data-animated-element]');
            animatedElements.forEach((el) => {
              el.classList.add('pause');
            });
            const targetContentIndex = hotspot.dataset.index;
            const targetContent = this.hotspotReveals[targetContentIndex];

            this.slider.setSlidePosition(this.slider.sliderItemOffset * targetContentIndex);

            targetContent.setAttribute('aria-hidden', 'false');
            this.staticContent.setAttribute('aria-hidden', 'true');
            this.closeOverlayButtons.forEach((button) => button.setAttribute('aria-hidden', 'false'));
          } else if (!event.target.closest('[data-hotspot-target]')) {
            this.closeAllReveals();
          }
        });
      }

      closeAllReveals() {
        this.hotspotButtons.forEach((button) => {
          const animatedElements = button.querySelectorAll('[data-animated-element]');
          animatedElements.forEach((el) => {
            el.classList.remove('pause');
          });
        });
        this.hotspotReveals.forEach((el) => {
          el.setAttribute('aria-hidden', 'true');
        });
        this.staticContent.setAttribute('aria-hidden', 'false');
        this.closeOverlayButtons.forEach((button) => button.setAttribute('aria-hidden', 'true'));
      }
    }
  );
}
